/**
 * @description axios方法封装
 * @author cht
 */

'use strict'
import axios from 'axios'
import selfMsgBox from '@/components/selfMsgBox'
import ss from '@/assets/common/ss'
import router from '@/router/index.js'
import store from '@/store'
function checkStatus (response) {
  if (!response || response.status !== 200) {
    selfMsgBox.error({
      message: '提示',
      messageExtra: '请求错误',
      closeBtn: false,
      btns: ['确 认']
    })
    // -1 请求错误
    // -2 需要登录
    // -3 其他业务错误
    return Promise.reject(new Error(-1))
  } else if (response.data.code !== '0') {
    // NWT-1004:柜台户首次登录需要设置登录密码, NWT-1005:操作员首次登录需要修改登录密码 NWT-1006:操作员登录需要设置交易密码 NWT-1008:操作员交易密码重置后需要重新修改交易密码
    let specialCode = ['ORG-CM0001', 'DS-TR0U0119', 'ORG-CM0002', 'ORG-CS9999', 'DS-TR021322', 'DS-TR0Q1125', 'DS-TR0Q1035', 'DS-TR021322', 'DS-TR0Q1036', 'DS-TR0Q1129','NWT-1004','NWT-1005','NWT-1006','NWT-1008', 'NWT-1021','DS-TR0Q1058','DS-TR041035','DS-TR041036','NWT-1009', 'NWT-1010', 'NWT-1012','NWT-1011', 'NWT-1022', 'NWT-1023', 'NWT-1027'];
    if (response.data.code == 'NWT-1002') { // 未登录或登录失效
      ss.removeItem('accountInfo');
      selfMsgBox.error({
        message: '提示',
        messageExtra: response.data.msg,
        closeBtn: false,
        btns: ['确 认'],
        onConfirm: () => {
          store.dispatch('loginOut').then(() => {
            router.push('/login');
          })
        }
      })
    } else if (/^DS-TR.+?0102$/.test(response.data.code)) {
      if (response.data.msg.indexOf('|') !== -1) {
        let buyErrorMsg = response.data.msg.split('|')[1]
        selfMsgBox.error({
          message: '提示',
          messageExtra: buyErrorMsg,
          closeBtn: false,
          btns: ['确 认']
        })
      } else {
        selfMsgBox.error({
          message: '提示',
          messageExtra: response.data.msg,
          closeBtn: false,
          btns: ['确 认']
        })
      }
    } else if (specialCode.indexOf(response.data.code) < 0) {
      selfMsgBox.error({
        message: '提示',
        messageExtra: response.data.msg,
        closeBtn: false,
        btns: ['确 认']
      })
    }

    return Promise.reject(response.data)
  } else {
    return response.data.data
  }
}

axios.defaults.withCredentials = true
// http request 拦截器
axios.interceptors.request.use(config => {
  if (config.method === 'post' && JSON.stringify(config.data) === '{}') {
    config.data = {'timestamp': new Date().getTime()}
  }
  if (config.method === 'get' && JSON.stringify(config.params) === '{}') {
    config.params = {'timestamp': new Date().getTime()}
  }

  if (window._signToken) {
    config.headers['Sign-Token'] = window._signToken
  }
  return config
}, error => {
  return Promise.reject(error)
})

// http response 拦截器
axios.interceptors.response.use(response => {
  // ie
  if (response.data && typeof response.data === 'string') {
    response.data = JSON.parse(response.data)
  }
  return checkStatus(response)
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '请求错误(400)'
        break
      case 401:
        if (error.response.data.data[0].error_no === 9007){
          error.message = '会话过期，请重新登录'
        } else if (error.response.data.data[0].error_no === 9){
          error.message = error.response.data.data[0].error_info
        } else {
          error.message = '未授权，请重新登录(401)'
        }
        break
      case 403:
        error.message = '拒绝访问(403)'
        break
      case 404:
        error.message = `请求出错(404)`
        break
      case 408:
        error.message = '请求超时(408)'
        break
      case 500:
        error.message = '服务器错误(500)'
        break
      case 501:
        error.message = '服务未实现(501)'
        break
      case 502:
        error.message = '网络错误(502)'
        break
      case 503:
        error.message = '服务不可用(503)'
        break
      case 504:
        error.message = '网络超时(504)'
        break
      case 505:
        error.message = 'HTTP版本不受支持(505)'
        break
      default:
        error.message = `连接出错(${error.response.status})!`
    }
  }

  // 取消请求不报错
  if (error.message === 'cancel') {
    return
  }

  if (error.response.config.headers['No-Error'] === '1') {
    return error
  }

  selfMsgBox.error({
    message: '提示',
    messageExtra: error.message,
    closeBtn: false,
    btns: ['确 认']
  })
  return Promise.reject(error)
})

let CancelToken = axios.CancelToken
let source = CancelToken.source()
const http = {
  get(url, params = {}) {
    return axios({
      method: 'get',
      baseURL: '',  // eslint-disable-line
      url,
      params,
      timeout: 1000 * 60 * 30,
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cancelToken: source.token
    })
  },
  post(url, data = {}, onUploadProgress = null, noError = false) { // eslint-disable-line no-unused-vars
    return axios({
      method: 'post',
      baseURL: '', // eslint-disable-line
      url,
      data,
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      timeout: 1000 * 60 * 30,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'No-Error': noError ? '1' : '0'
      },
      cancelToken: source.token
    })
  },
  all(iterable) {
    return axios.all(iterable).then(response => {
      return response
    })
  },
  cancel () {
    source.cancel('cancel')
    // 赋值新source，否则之后的请求会全部被取消
    source = CancelToken.source()
  }
}
export default http



// WEBPACK FOOTER //
// ./src/assets/common/http.js